import React, {Component} from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import {
  postSchema,
  getSelectableSchemaYears,
  getAssociatedCompanies,
  postCreateNewChemaYear,
  ESGScopeTypes
} from '../../../../actions/esg'

// Elements
import Col from './../../../../shared/elements/col'
import Row from './../../../../shared/elements/row'
import Panel from './../../../../shared/elements/panel'
import Text from './../../../../shared/elements/text'
import Switch from './../../../../shared/elements/switch'
import DropDown from '../../../../shared/elements/dropDown'
import Button from '../../../../shared/elements/button'

// Utils
import { translation } from '../../../../utils/helpers'

// Subcomponents
import Scopes from './components/scopes'
import CompanySelection from './components/companySelection'

import Portal from '../../../../shared/components/Portal'
import BottomBar from '../../../../shared/elements/bottomBar'
import ModalHeader from '../../../../shared/elements/modalHeader'

import './index.scss'

class View extends Component {
  constructor (props) {
    super(props)
    this.resetSchema = {
      Id: 0,
      Name: '',
      IsActive: true,
      StartYear: new Date().getFullYear()
    }
    this.state = {
      type: 'edit',
      schema: this.resetSchema,
      selectableYears: [],
      selectedYear: 0,
      showPortal: false
    }

    // add years 10 years back and in future
    this.selectableStartYears = []
    for (let i = -10; i <= 10; i++) {
      this.selectableStartYears.push(new Date().getFullYear() + i)
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onInputChangeSave = this.onInputChangeSave.bind(this)
    this.updateSchema = this.updateSchema.bind(this)
    this.saveAddSchema = this.saveAddSchema.bind(this)
  }

  componentDidMount () {
    this.getSelectableSchemaYears(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.Id !== nextProps.item.Id) {
      this.getSelectableSchemaYears(nextProps)
    }
  }

  getSelectableSchemaYears (props) {
    if (typeof props.item.Id !== 'undefined' && props.item.Id > 0) {
      this.setState({schema: props.item})
      this.props.getSelectableSchemaYears(props.item.Id).then(res => {
        this.setState({
          selectableYears: res.data,
          selectedYear: res.data.at(-1)
        })
      })
    } else {
      this.resetCreate()
    }
  }

  updateSchema () {
    this.props.postSchema(this.state.schema).then((res) => {
      this.props.onSave(res.data, this.state.type)
      let newState = { schema: res.data }
      if (this.state.type === 'create') {
        newState.type = 'edit'
      }
      this.setState({ ...newState })
      this.props.updateListItem(newState.schema)
    }, () => {
      // Toastr
      window.toastr.error(translation('18408'), translation('216'))
      // if (Array.isArray(err.response.data.Errors) && err.response.data.Errors.length > 0) {
      //   let errors = err.response.data.Errors
      //   let errText = ''
      //   for (let i = 0; i < errors.length; i++) {
      //     let dictKey = errors[i].DictionaryKey
      //     if (errText !== '') errText += '<br/>'
      //     errText += translation(dictKey)
      //   }
      //   window.toastr.error(translation(errText), translation('216'))
      // } else {
      //   window.toastr.error(translation('18408'), translation('216'))
      // }
    })
  }

  saveAddSchema () {
    if (this.state.type !== 'create') this.updateSchema()
  }

  onInputChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (e === undefined) {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      schema: {
        ...this.state.schema,
        [name]: value
      }
    })
  }

  onInputChangeSave (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (e === undefined) {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      schema: {
        ...this.state.schema,
        [name]: value
      }
    }, this.saveAddSchema)
  }

  resetCreate () {
    this.setState({
      type: 'create',
      schema: this.resetSchema
    })
  }

  renderSchema () {
    let schema = this.state.schema
    let isCreate = this.state.type === 'create'

    return (
      <Panel title={translation('18404')}>
        <Text name='Name' value={schema.Name || ''} onChange={this.onInputChange} onBlur={this.saveAddSchema} labelText={translation('30')} />
        <Switch name='IsActive' checked={schema.IsActive || false} onChange={this.onInputChangeSave} labelText={translation('295')} />
        {isCreate && (
          <DropDown name='StartYear' value={schema.StartYear} onChange={this.onInputChangeSave} labelText={translation(18428)}>
            {this.selectableStartYears.map((year, k) => {
              return <option key={k} value={year}>{year}</option>
            })}
          </DropDown>
      )}
      </Panel>
    )
  }

  rederAddScope () {
    if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null

    const addScope = () => {
      this.refs.scopes.getWrappedInstance().addScope()
    }

    return (
      <Panel title={translation(18405)}>
        <Button style='secondary' onClick={addScope} labelText={translation('1208')} />
      </Panel>
    )
  }

  renderYear () {
    if (!(this.state.schema.Id > 0) || this.state.type === 'create') return null

    const createYear = (isCopy) => {
      closePortal()
      this.props.postCreateNewChemaYear(this.state.schema.Id, isCopy ? this.state.selectedYear : undefined).then((res) => {
        this.setState({
          selectableYears: res.data,
          selectedYear: res.data.at(-1)
        })
        // window.toastr.success(translation(18424), translation('13424'))
      }, () => {
        window.toastr.error(translation('960'), translation('216'))
      })
    }

    const onChange = (item) => {
      this.setState({ selectedYear: parseInt(item.target.value) })
    }

    const openPortal = () => this.setState({ showPortal: true })
    const closePortal = () => this.setState({ showPortal: false })
    return (
      <Panel title={translation(18407)}>
        <DropDown value={this.state.selectedYear} onChange={onChange} labelText={translation(18407)}>
          {this.state.selectableYears.map((year, k) => {
            return <option key={k} value={year}>{year}</option>
          })}
        </DropDown>
        <Button style='secondary' onClick={openPortal} labelText={translation(18420)} />
        {this.state.showPortal === true && (
          <Portal onPortalClose={closePortal}>
            <div className='confirm__modal__wrapper'>
              <div className={'backdrop__modal'} />
              <div className='confirm__modal schema_newYear_modal'>
                <div className='confirm__content'>
                  <ModalHeader text={translation(18420)} />
                  <div className='pg-pb-2'>{translation(18423, { nextYear: this.state.selectableYears.at(-1) + 1, selectedYear: this.state.selectedYear })}</div>
                </div>
                <BottomBar
                  actionStyle='secondary'
                  actionLabelText={translation(18421)}
                  onActionClick={() => createYear(true)}
                  cancelLabelText={translation(570)}
                  onCancelClick={closePortal}>
                  <Button spacing={0} style='secondary' onClick={() => createYear(false)} labelText={translation(18422)} />
                </BottomBar>
              </div>
            </div>
          </Portal>
        )}
      </Panel>
    )
  }

  renderCompanySelection () {
    if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null

    return (
      <Panel title={translation(1861)}>
        <CompanySelection schemaId={this.state.schema.Id} year={this.state.selectedYear} />
      </Panel>
    )
  }

  renderScopes () {
    if (!(this.state.selectedYear > 0) || this.state.type === 'create') return null

    return [
      <Scopes key={0} schemaId={this.state.schema.Id} year={this.state.selectedYear} scopeType={ESGScopeTypes.ManualReporting} />,
      <Scopes key={1} ref='scopes' schemaId={this.state.schema.Id} year={this.state.selectedYear} scopeType={ESGScopeTypes.Default} />
    ]
  }

  render () {
    return (
      <Row>
        <Col>
          {this.renderSchema()}
          {this.renderYear()}
          {this.renderCompanySelection()}
          {this.rederAddScope()}
        </Col>
        {this.renderScopes()}
      </Row>
    )
  }

}

export default connect(null, {
  postSchema,
  getSelectableSchemaYears,
  getAssociatedCompanies,
  postCreateNewChemaYear
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Chain/View/index.js